import $ from 'jquery';
import { breakpoints } from './_site';
import { create as initSlider, destroy as destroySlider } from './slider';

export const timeout = {};
export const resize = () => {
    var $window = $(window);

    // md
    if ($window.width() < breakpoints.md) {
        responsiveSlider(true);
    } else {
        responsiveSlider(false);
    }
};
export const createSlider = ($el) => {
    var isSingle = $el.is('.testimonials-list--single'),
        options = {
            fade: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: breakpoints.md,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        // autoplay: true,
                        // autoplaySpeed: 5000
                    },
                },
            ],
        };

    if (isSingle) {
        options.slidesToShow = 1;
        options.slidesToScroll = 1;
    }

    initSlider($el, options);
};
export const createAlternateSlider = ($el) => {
    var options = {
        fade: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: breakpoints.md,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    // autoplay: true,
                    // autoplaySpeed: 5000
                },
            },
        ],
    };

    initSlider($el, options);
};
export const responsiveSlider = (flag) => {
    var $el = $('.testimonials-list.mobile');

    if (flag) {
        createSlider($el);
    } else {
        destroySlider($el);
    }
};
export const binds = () => {
    createSlider($('.testimonials-list').not('.mobile'));
    createAlternateSlider($('.testimonial-slider'));

    $(window).on('resize.testimonials', function() {
        clearTimeout(timeout.resize);
        timeout.resize = setTimeout(function() {
            resize();
        }, 100);
    });
    $(window).triggerHandler('resize.testimonials');
};
